module.exports = __webpack_public_path__ + "img/Mode_Selector_HoldemBet.3e35f2c6.png";